import tools from '../../tools';
import ToolbarGroup from './ToolbarGroup';

const standardTools = [
  [
    tools.ToolStrikethrough,
    tools.ToolCodeSnippet,
    tools.ToolTextColor,
    tools.ToolTextHighlight,
  ],
  [tools.ToolFontFamily, tools.ToolFontSize],
  [tools.ToolClearFormatting],
];

const compactTools = [
  [tools.ToolBold, tools.ToolItalic, tools.ToolUnderline],
  [
    tools.ToolStrikethrough,
    tools.ToolCodeSnippet,
    tools.ToolTextColor,
    tools.ToolTextHighlight,
  ],
  [tools.ToolFontFamily, tools.ToolFontSize],
  [tools.ToolClearFormatting],
];

const ToolbarFormattingMenu = ({ compact }: { compact?: boolean } = {}) =>
  ToolbarGroup({
    menu: {
      icon: 'fa-regular fa-font',
      name: 'Formatting',
      tools: compact ? compactTools : standardTools,
    },
  });
export default ToolbarFormattingMenu;
